// @flow strict

import * as React from 'react';
import Articles from '../NewsLanding/Internal/Articles';
import type { ArticleType } from '../NewsLanding/Internal/types';
import Pagination from '../../internal/Pagination';
import PageContentBlock from '../../internal/PageContentBlock';
import Search from '../../internal/Search';
import styles from './styles.scss';

type PropType = {|
  title: string,
  results: Array<ArticleType>,
  totalResults: number,
  page: number,
  totalPages: number,
  urlTemplate: string,
  fieldName: string,
  action: string,
  searchTerm?: string,
|};

export default (props: PropType) => {
  return (
    <PageContentBlock>
      <div>
        <h1 className={styles.title}>{props.title}</h1>
        <Search
          className={styles.search}
          searchTerm={props.searchTerm}
          action={props.action}
          fieldName={props.fieldName}
          placeholder="Search blog"
        />
        <h2 className={styles.subtitle}>
          {props.totalResults} result{props.totalResults === 1 ? '' : 's'} for &quot;
          {props.searchTerm}&quot; found
        </h2>
      </div>

      <Articles articles={props.results} columns={3} />

      <div className={styles.pagination}>
        <Pagination
          selected={props.page}
          total={props.totalPages}
          urlTemplate={props.urlTemplate}
        />
      </div>
    </PageContentBlock>
  );
};
